<template>
    <v-data-table v-bind="{ items, headers }" :items-per-page="-1" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined nshop-order-view-section" no-data-text="발급된 상품권이 없습니다">
        <template #top> <div class="table-label px-1 white">상품권</div> </template>
        <template v-for="(header, index) in headers.filter((h) => h.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { initDataTableHeaders } from "@/assets/lib";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            return this.order?.pins || [];
        },
        headers() {
            return initDataTableHeaders([
                { text: "PIN", value: "pno" },
                { text: "권종", value: "faceamt", align: "end", formatterType: "number", formatterSuffix: "원" },
                { text: "충전여부", value: "isGained", align: "center", formatter: (v) => (v ? "충전완료" : "미충전") },
                { text: "발급일시", value: "issuedAt", formatterType: "datetime" },
            ]);
        },
    },
};
</script>
